/** The "I accept..." checkbox every self-registration form gates submission on. */
export function TermsCheckbox({
  checked,
  onChange,
}: {
  checked: boolean
  onChange: (checked: boolean) => void
}) {
  return (
    <label className="flex items-start gap-2 text-sm text-ink-700">
      <input
        required
        type="checkbox"
        className="mt-1"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span>
        I accept the{' '}
        <a href="/terms" target="_blank" rel="noopener noreferrer" className="font-semibold text-dot-700 underline underline-offset-2">
          Terms &amp; Conditions
        </a>{' '}
        and{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer" className="font-semibold text-dot-700 underline underline-offset-2">
          Privacy Policy
        </a>{' '}
        of YellowDots AI.
      </span>
    </label>
  )
}
